const events = {
  MOUNTED_MODAL_CONFIRM: "mountedModalConfirm",
  SHOW_MODAL_CONFIRM: "showModalConform",
  CLOSE_MODAL_CONFIRM: "closeModalConfirm",
  ACCEPT_MODAL_CONFIRM: "acceptModalConfirm"
};

export default events;
